import React from 'react'
import { AuthRoles } from "components/auth";

export const DispatchesConfig = {
    auth: AuthRoles.admin,
    routes: [
        {
            path: `${process.env.PUBLIC_URL}/dispatches`,
            component: React.lazy(() => import('./Dispatches'))
        }
    ]
}
